const COLORS = Object.freeze({
  grays: Object.freeze({
    black: '#000000',
    gray80: '#323232',
    gray55: '#717171',
    gray25: '#bebebe',
    gray12: '#e1e2e3',
    gray6: '#edeeef',
  }),
  // lower numbers = darker colors
  reds: Object.freeze({
    red1: '#ce3139',
    red2: '#ee3a43',
    red3: '#f48474',
    red4: '#f8aa99',
    red5: '#fcd6ca',
  }),
  blues: Object.freeze({
    blue1: '#0079ae',
    blue2: '#0098db',
    blue3: '#95cbee',
    blue4: '#c9e2f5',
    blue5: '#e6eff9',
  }),
  greens: Object.freeze({
    green1: '#52a045',
    green2: '#63bc51',
    green3: '#a2d292',
    green4: '#c6e2ba',
    green5: '#e6f2e1',
  }),
  oranges: Object.freeze({
    orange1: '#e29320',
    orange2: '#f9a224',
    orange3: '#fdc47c',
  }),
  yellows: Object.freeze({
    yellow1: '#edc639',
    yellow2: '#ffd63d',
  }),
  wines: Object.freeze({
    wine1: '#bb2b77',
    wine2: '#d991b2',
  }),
  champagnes: Object.freeze({
    champagne1: '#eee2bd',
    champagne2: '#f5eeda',
  }),
  mansion: Object.freeze({
    mansion1: '#c3a730',
    mansion2: '#bfb980',
    mansion3: '#dedab9',
  }),
  transparent: Object.freeze({
    transparent: 'rgba(0, 0, 0, 0)',
  }),
});

export const WSJ_COLORS = COLORS;

export const ELECTION_COLORS = Object.freeze({
  reds: Object.freeze({
    red1: '#b1282e',
    red2: COLORS.reds.red1,
    red3: COLORS.reds.red2,
    red4: COLORS.reds.red3,
    red5: COLORS.reds.red4,
    red6: COLORS.reds.red5,
  }),
  blues: Object.freeze({
    blue1: '#005d88',
    blue2: '#007bb1',
    blue3: COLORS.blues.blue2,
    blue4: '#76bde8',
    blue5: '#b5d7f1',
    blue6: '#d8e7f6',
  }),
  teals: Object.freeze({
    teal1: '#90d4d8',
  }),
  purples: Object.freeze({
    purple1: '#683c8e',
  }),
  greens: Object.freeze({
    green1: COLORS.greens.green2,
  }),
  coolGrays: Object.freeze({
    coolGray1: '#9399ad',
  }),
  golds: Object.freeze({
    gold1: '#f5e6a8',
  }),
  grays: Object.freeze({
    gray1: '#898b8e',
    gray2: '#dbdcde',
  }),
});

const NEUTRALS = [
  COLORS.mansion.mansion2,
  COLORS.mansion.mansion3,
  COLORS.grays.gray55,
  COLORS.grays.gray25,
  COLORS.grays.gray12,
];

export const WORLD_US_NY = Object.freeze({
  name: 'Blue Theme',
  theme: Object.freeze([COLORS.blues.blue1, COLORS.blues.blue2, COLORS.blues.blue3, ...NEUTRALS]),
});

export const BUSINESS_TECH = Object.freeze({
  name: 'Red Theme',
  theme: Object.freeze([COLORS.reds.red1, COLORS.reds.red2, COLORS.reds.red5, ...NEUTRALS]),
});

export const MI_BIZ_FINANCE = Object.freeze({
  name: 'Green Theme',
  theme: Object.freeze([
    COLORS.greens.green1,
    COLORS.greens.green2,
    COLORS.greens.green4,
    ...NEUTRALS,
  ]),
});

export const WSJ_OPINION = Object.freeze({
  name: 'Gold Theme',
  theme: Object.freeze([
    COLORS.mansion.mansion1,
    COLORS.yellows.yellow1,
    COLORS.champagnes.champagne1,
    COLORS.grays.gray25,
    COLORS.grays.gray80,
    COLORS.grays.gray55,
    COLORS.grays.gray12,
    COLORS.blues.blue3,
  ]),
});

export const WSJ_VIDEO = Object.freeze({
  name: 'WSJ Video',
  theme: Object.freeze([
    '#0294e8',
    '#026ba8',
    '#1425b5',
    '#e81a21',
    '#e8e41a',
    '#9c9909',
    '#e84b0d',
    '#9c3811',
    '#d8d8d8',
    '#999999',
    '#555555',
  ]),
});

export const WSJ_WAGE_GROWTH = Object.freeze({
  name: 'WSJ Wage Growth',
  theme: Object.freeze([COLORS.blues.blue1, COLORS.blues.blue3, COLORS.oranges.orange2]),
});

const ECON_DATA_BLUE_GREEN = [COLORS.blues.blue1, COLORS.greens.green2];

export const WSJ_PRIME_AGE = Object.freeze({
  name: 'WSJ Prime Age',
  theme: ECON_DATA_BLUE_GREEN,
});

export const WSJ_LABOR_FORCE = Object.freeze({
  name: 'WSJ Labor Force',
  theme: ECON_DATA_BLUE_GREEN,
});

export const WSJ_MEN_WOMEN = Object.freeze({
  name: 'WSJ Men Women',
  theme: Object.freeze([
    COLORS.blues.blue3,
    COLORS.blues.blue1,
    COLORS.greens.green3,
    COLORS.greens.green1,
    COLORS.oranges.orange3,
    COLORS.oranges.orange1,
  ]),
});

export const WSJ_COLOR_THEMES = Object.freeze({
  wsj_world: WORLD_US_NY,
  wsj_biztech: BUSINESS_TECH,
  wsj_mibizfin: MI_BIZ_FINANCE,
  wsj_op: WSJ_OPINION,
  wsj_video: WSJ_VIDEO,
  wsj_wage_growth: WSJ_WAGE_GROWTH,
  wsj_prime_age: WSJ_PRIME_AGE,
  wsj_labor_force: WSJ_LABOR_FORCE,
  wsj_men_women: WSJ_MEN_WOMEN,
});

export const WSJ_PLOT_LINE_COLORS = [COLORS.grays.gray80, COLORS.grays.gray25];

export const WSJ_VIDEO_PLOT_LINE_COLORS = [WSJ_VIDEO.theme[9], WSJ_VIDEO.theme[5]];
